import React from 'react';
import { Button } from '@trevor/ui-components';
import { useRefreshQuery } from '@/views/QueryBuilder/hooks/useRefreshQuery';

export const RefreshResultsButton = () => {
  const refresh = useRefreshQuery();

  return (
    <Button variant="secondary" size="small" onClick={refresh}>
      Refresh results
    </Button>
  );
};
